<template>
  <transition name="envelope-fade">
    <div class="hb-overlay" v-if="visible" @click.self="close">
      <!-- 未开状态：微信红包样式 -->
      <div class="hb-wrapper" v-if="!claimed">
        <!-- 关闭按钮 -->
        <button class="hb-close" @click="close">&times;</button>

        <!-- 红包主体 -->
        <div class="hb-body">
          <!-- 顶部区域 -->
          <div class="hb-top">
            <div class="hb-sender-avatar">
              <svg viewBox="0 0 1024 1024" width="44" height="44"><path d="M401.371429 1024c-27.771429 0-53.714286-14.057143-68.914286-37.371429C274.285714 972.571429 232.114286 945.142857 203.428571 902.971429c-30.4-44.8-45.942857-105.942857-49.028571-192.571429-0.457143-12.342857-1.257143-25.6-2.514286-40.685714-31.657143-17.142857-57.371429-45.828571-71.771428-81.028572-10.742857-25.828571-14.514286-54.171429-10.857143-81.942857-14.514286-15.085714-25.942857-32.685714-33.828572-52-17.6-42.742857-16.228571-88.914286 2.628572-126.514286-13.371429-42.171429-11.657143-86.971429 4.914286-125.257142 16.457143-37.828571 46.057143-66.285714 83.428571-80.342858 13.6-5.142857 28-8.228571 42.514286-9.142857 21.257143-22.057143 53.371429-36.342857 91.885714-40.457143 38.057143-30.857143 85.6-47.542857 134.514286-47.428571 11.085714 0 22.171429 0.8 33.142857 2.514286 65.828571-37.485714 146.4-37.485714 212.228571 0 70.742857-10.971429 142.4 14.057143 190.857143 66.742857 8.685714 5.142857 16.685714 11.542857 23.657143 18.742857 14.628571 0.914286 28.914286 4 42.628571 9.142857 37.371429 14.057143 66.971429 42.628571 83.428572 80.342857 16.685714 38.285714 18.285714 83.2 4.914286 125.257143 18.857143 37.6 20.228571 83.771429 2.628571 126.514286-7.885714 19.314286-19.428571 37.028571-33.942857 52 3.542857 27.771429-0.114286 56-10.857143 81.828571-14.4 35.2-40.228571 63.885714-71.771429 81.028572-1.257143 15.085714-2.057143 28.342857-2.514285 40.685714-3.085714 86.628571-18.628571 147.771429-49.028572 192.571429-28.571429 42.171429-70.857143 69.6-129.028571 83.657142-15.2 23.314286-41.028571 37.371429-68.914286 37.371429H401.371429z" fill="#25467A"/><path d="M401.371429 893.485714h221.371428c19.542857 0 35.314286 15.771429 35.314286 35.314286v13.028571c0 19.542857-15.771429 35.314286-35.314286 35.314286H401.371429c-19.542857 0-35.314286-15.771429-35.314286-35.314286v-13.028571c0-19.428571 15.771429-35.314286 35.314286-35.314286z" fill="#FDEFBA"/><path d="M673.714286 72.457143c-14.285714 0-28.457143 1.828571-42.285715 5.371428-58.057143-41.257143-135.771429-41.257143-193.828571 0-89.371429-23.314286-180.8 30.171429-204.228571 119.542858S263.542857 378.285714 353.028571 401.6c47.885714 12.457143 98.857143 3.2 139.2-25.485714 27.771429 7.2 56.914286 7.2 84.685715 0 75.314286 53.485714 179.771429 35.885714 233.257143-39.542857s35.885714-179.771429-39.542858-233.257143c-28.342857-20.114286-62.171429-30.857143-96.914285-30.857143z" fill="#689F38"/><path d="M750.4 423.428571c-15.771429-22.742857-37.485714-39.085714-60.457143-47.771428 19.428571-31.542857 10.628571-78.857143-24.571428-115.885714-29.828571-31.314286-70.742857-46.628571-105.142858-42.742858-10.514286-19.542857-28.228571-38.285714-52-52.914285-41.6-25.6-89.371429-31.085714-121.6-16.8-18.057143-11.428571-40.457143-20.457143-65.142857-25.142857-60.228571-11.657143-114.285714 5.485714-129.257143 38.857142-16.685714-2.285714-33.714286-0.457143-49.485714 5.485715-58.057143 21.828571-83.085714 93.028571-56 159.085714 1.028571 2.628571 2.171429 5.142857 3.428572 7.657143-21.371429 26.171429-27.085714 65.942857-11.542858 103.657143 8.685714 21.6 23.771429 40 43.085715 52.914285-9.6 23.885714-9.828571 53.028571 1.714285 81.028572 21.828571 52.914286 77.257143 81.714286 123.885715 64.228571s66.742857-74.628571 44.914285-127.657143c-8.8-21.6-23.771429-40-43.085714-52.914285 6.857143-17.485714 8.8-36.571429 5.6-55.085715 41.485714-23.314286 61.371429-74.514286 50.4-126.971428 28.457143 4.685714 55.2 2.971429 76.8-3.885714 9.257143 9.485714 19.657143 17.828571 30.971429 24.685714 29.371429 18.057143 61.714286 26.171429 89.6 24.228571 6.285714 17.6 16.228571 33.6 29.257143 46.971429 16.114286 17.028571 36.114286 29.828571 58.285714 37.257143-18.857143 29.257143-16.457143 72.457143 9.371428 109.6 33.828571 48.685714 95.085714 68.457143 136.685715 44.114285s48.114286-83.314286 14.285714-132z" fill="#AED581"/><path d="M799.771429 700.8c10.4 126.057143 5.714286 253.257143-232.457143 253.257143S210.171429 958.857143 201.257143 708.8c-6.971429-197.371429-102.171429-470.057143 136-470.057143s446.171429 263.428571 462.514286 462.057143z" fill="#FFFDE7"/><path d="M933.828571 333.257143c1.142857-2.514286 2.285714-5.028571 3.428572-7.657143 27.2-66.057143 2.057143-137.257143-56-159.085714-15.771429-5.828571-32.8-7.771429-49.485714-5.371429-14.971429-33.257143-69.028571-50.4-129.257143-38.857143-24.685714 4.8-47.085714 13.714286-65.142857 25.142857-32.228571-14.285714-80-8.914286-121.6 16.8-23.657143 14.628571-41.485714 33.371429-52 52.914286-34.4-4-75.2 11.428571-105.028572 42.742857-20.571429 21.6-32.114286 46.742857-34.285714 70.171429-25.142857 7.771429-49.485714 25.028571-66.742857 49.828571-19.885714 28.571429-25.828571 60.685714-19.085715 87.314286-18.971429 17.6-32.228571 40.457143-38.171428 65.6-13.942857 57.6 13.485714 110.514286 61.028571 118.057143s97.485714-33.028571 111.428572-90.628572c4.914286-20.342857 352.571429-47.2 357.257143-48.457142-19.085714 51.771429 1.142857 106.4 46.514285 123.428571 46.628571 17.485714 102.057143-11.2 123.885715-64.228571 11.542857-28 11.314286-57.142857 1.714285-81.028572 19.314286-12.914286 34.285714-31.428571 43.085715-52.914286 15.542857-37.828571 9.828571-77.6-11.542858-103.771428z" fill="#9CCC65"/><path d="M224.228571 700.8c-10.4 126.057143-5.828571 253.257143 232.457143 253.257143s357.257143 4.8 366.057143-245.257143c7.085714-197.371429 44.685714-342.742857-193.485714-342.742857s-388.571429 136.114286-405.028572 334.742857z" fill="#FFFEF8"/><path d="M512 827.657143c-38.171429 0-69.142857-30.971429-69.142857-69.257143 0-7.657143 6.171429-13.828571 13.828571-13.942857 7.314286 0 13.485714 5.714286 13.828572 13.028571v0.8c0.342857 22.971429 19.314286 41.257143 42.171428 40.8 22.4-0.342857 40.457143-18.4 40.8-40.8-0.228571-7.657143 5.828571-14.057143 13.371429-14.285714 7.657143-0.228571 14.057143 5.828571 14.285714 13.371429v0.8c0 38.4-30.971429 69.371429-69.142857 69.485714zM332.114286 647.771429c0.342857 22.971429 19.314286 41.257143 42.171428 40.8 22.4-0.342857 40.457143-18.4 40.8-40.8-0.342857-22.971429-19.314286-41.257143-42.171428-40.8-22.4 0.342857-40.457143 18.4-40.8 40.8zM608.8 647.771429c-0.342857 22.971429 17.828571 41.828571 40.8 42.285714 22.971429 0.342857 41.828571-17.828571 42.285714-40.8v-1.485714c-0.342857-22.971429-19.314286-41.257143-42.171428-40.8-22.4 0.342857-40.457143 18.4-40.914286 40.8z" fill="#25467A"/><path d="M318.285714 716.914286h-55.314285c-15.314286 0.342857-27.428571 12.914286-27.085715 28.228571 0.342857 14.857143 12.228571 26.857143 27.085715 27.085714h55.428571c15.314286 0.342857 27.885714-11.771429 28.228571-27.085714 0.342857-15.314286-11.771429-27.885714-27.085714-28.228571h-1.257143z m442.742857 0h-55.314285c-15.314286 0.342857-27.428571 12.914286-27.085715 28.228571 0.342857 14.857143 12.228571 26.857143 27.085715 27.085714h55.314285c15.314286-0.342857 27.428571-12.914286 27.085715-28.228571-0.228571-14.857143-12.228571-26.742857-27.085715-27.085714z" fill="#AED581"/></svg>
            </div>
            <div class="hb-sender-name">白菜</div>
            <div class="hb-greeting">{{ envelope.content }}</div>
          </div>

          <!-- 中间开按钮 -->
          <div class="hb-open-area">
            <button class="hb-open-btn" @click="claimEnvelope" :disabled="claiming" :class="{ 'is-loading': claiming }">
              <span class="hb-open-text">{{ claiming ? '' : '开' }}</span>
              <span v-if="claiming" class="hb-loading"></span>
            </button>
          </div>

          <!-- 底部信息 -->
          <div class="hb-bottom">
            <span>已有{{ envelope.claimCount || 0 }}人领取</span>
          </div>
        </div>

        <!-- 今日不再显示 -->
        <button class="hb-dismiss" @click="dismissToday">今日不再显示</button>
      </div>

      <!-- 已开状态：展示金额 -->
      <div class="hb-result" v-else>
        <button class="hb-close hb-close-dark" @click="close">&times;</button>
        <div class="hb-result-inner">
          <div class="hb-result-title">白菜的红包</div>
          <div class="hb-result-amount">
            <span class="hb-amount-num">{{ claimedAmount }}</span>
            <span class="hb-amount-unit">元</span>
          </div>
          <div class="hb-result-tip">已存入余额</div>
          <div class="hb-result-count">已有{{ envelope.claimCount || 0 }}人领取</div>
        </div>
        <button class="hb-dismiss hb-dismiss-light" @click="dismissToday">今日不再显示</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { apiFetch } from '@/config/api'

export default {
  name: 'RedEnvelopePopup',
  data() {
    return {
      visible: false,
      claiming: false,
      claimed: false,
      claimedAmount: '0.00',
      envelope: {
        id: null,
        title: '',
        content: '',
        maxAmount: 0,
        claimCount: 0
      }
    }
  },
  mounted() {
    this.fetchRedEnvelope()
  },
  methods: {
    async fetchRedEnvelope() {
      try {
        const res = await apiFetch('/api/red-envelope/active')
        if (res && res.code === 0 && res.data) {
          this.envelope = res.data
          this.claimed = res.data.claimed || false
          this.claimedAmount = res.data.claimedAmount || '0.00'

          // 已领取过的不再显示
          if (this.claimed) return

          const key = 'red_envelope_dismissed_' + res.data.id
          const dismissed = localStorage.getItem(key)
          const today = new Date().toISOString().slice(0, 10)
          if (dismissed !== today) {
            this.visible = true
          }
        }
      } catch (e) {
        // 静默处理
      }
    },
    async claimEnvelope() {
      if (!this.envelope.id || this.claiming) return
      this.claiming = true
      try {
        const res = await apiFetch('/api/red-envelope/claim/' + this.envelope.id, {
          method: 'POST'
        })
        if (res && res.code === 0) {
          this.claimedAmount = res.amount
          this.envelope.claimCount = (this.envelope.claimCount || 0) + 1
          // 显示金额结果页
          this.claimed = true
        } else {
          if (res.amount) {
            // 已领取过，显示金额
            this.claimed = true
            this.claimedAmount = res.amount
          } else {
            alert(res.msg || '领取失败')
          }
        }
      } catch (e) {
        alert('领取失败，请重试')
      }
      this.claiming = false
    },
    close() {
      this.visible = false
    },
    dismissToday() {
      if (this.envelope.id) {
        const key = 'red_envelope_dismissed_' + this.envelope.id
        const today = new Date().toISOString().slice(0, 10)
        localStorage.setItem(key, today)
      }
      this.visible = false
    }
  }
}
</script>

<style scoped>
/* 过渡动画 */
.envelope-fade-enter-active,
.envelope-fade-leave-active {
  transition: opacity 0.3s ease;
}
.envelope-fade-enter-from,
.envelope-fade-leave-to {
  opacity: 0;
}

/* 遮罩层 */
.hb-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* ======== 未开封红包 ======== */
.hb-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hb-body {
  width: 280px;
  background: #C4392A;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

/* 红包顶部黄金分割线装饰 */
.hb-body::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  background:
    linear-gradient(180deg, #E05A4E 0%, #C4392A 40%, #C4392A 100%);
  z-index: 0;
}

.hb-body::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 204px;
  transform: translateX(-50%);
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, #D4725A 30%, #E8A070 50%, #D4725A 70%, transparent 100%);
  z-index: 1;
}

/* 关闭按钮 */
.hb-close {
  position: absolute;
  top: -40px;
  right: -8px;
  background: none;
  border: none;
  font-size: 28px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  line-height: 1;
  padding: 4px 8px;
  z-index: 10;
}

.hb-close:hover {
  color: #fff;
}

.hb-close-dark {
  color: rgba(0, 0, 0, 0.3);
  top: 8px;
  right: 8px;
}
.hb-close-dark:hover {
  color: rgba(0, 0, 0, 0.6);
}

/* 顶部内容 */
.hb-top {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 36px 30px 24px;
}

.hb-sender-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  overflow: hidden;
  padding: 4px;
  box-sizing: border-box;
}

.hb-sender-name {
  font-size: 17px;
  font-weight: 500;
  color: #FFECD2;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
}

.hb-greeting {
  font-size: 24px;
  font-weight: 400;
  color: #FFF1DB;
  text-align: center;
  line-height: 1.4;
  letter-spacing: 2px;
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 220px;
}

/* 开按钮区域 */
.hb-open-area {
  position: relative;
  z-index: 3;
  display: flex;
  justify-content: center;
  padding: 20px 0 28px;
}

.hb-open-btn {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(145deg, #F7CE68, #E2A83E);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.15),
    inset 0 1px 2px rgba(255, 255, 255, 0.3);
  transition: transform 0.2s ease;
  position: relative;
}

.hb-open-btn:hover {
  transform: scale(1.08);
}

.hb-open-btn:active {
  transform: scale(0.96);
}

.hb-open-btn:disabled {
  cursor: wait;
  transform: none;
}

.hb-open-btn.is-loading {
  animation: hb-pulse 1s ease infinite;
}

@keyframes hb-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.06); }
}

.hb-open-text {
  font-size: 30px;
  font-weight: 700;
  color: #B8460E;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  user-select: none;
}

.hb-loading {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(184, 70, 14, 0.2);
  border-top-color: #B8460E;
  border-radius: 50%;
  animation: hb-spin 0.6s linear infinite;
}

@keyframes hb-spin {
  to { transform: rotate(360deg); }
}

/* 底部信息 */
.hb-bottom {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 0 0 20px;
  font-size: 12px;
  color: rgba(255, 230, 200, 0.5);
}

/* ======== 已领取结果页 ======== */
.hb-result {
  width: 280px;
  background: #fff;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
}

.hb-result-inner {
  padding: 48px 30px 30px;
  text-align: center;
}

.hb-result-title {
  font-size: 15px;
  color: #888;
  margin-bottom: 24px;
}

.hb-result-amount {
  margin-bottom: 8px;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.hb-amount-num {
  font-size: 52px;
  font-weight: 300;
  color: #C4392A;
  font-family: DINAlternate, "Helvetica Neue", Arial, sans-serif;
  line-height: 1;
}

.hb-amount-unit {
  font-size: 18px;
  color: #C4392A;
  margin-left: 4px;
  font-weight: 400;
}

.hb-result-tip {
  font-size: 13px;
  color: #999;
  margin-bottom: 20px;
}

.hb-result-count {
  font-size: 12px;
  color: #bbb;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

/* 今日不再显示 */
.hb-dismiss {
  margin-top: 20px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  cursor: pointer;
  padding: 6px 12px;
  transition: color 0.15s;
}

.hb-dismiss:hover {
  color: rgba(255, 255, 255, 0.8);
}

.hb-dismiss-light {
  display: block;
  width: 100%;
  color: #bbb;
  padding: 12px;
  border-top: 1px solid #f0f0f0;
  margin-top: 0;
  font-size: 12px;
}

.hb-dismiss-light:hover {
  color: #666;
  background: #fafafa;
}
</style>
